import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { feedback } from "./appShell";
import { IconChevronLeft, IconEntree, IconWarning } from "./icons";
import { badgeScanEntree, formatDate } from "./statuts";
import "./styles.css";

//const API_URL = "https://localhost:8443/api/assets/validate";
const API_URL = "https://app.bicadev.com/api/assets/validate";

export default function ScanPage() {
  const navigate = useNavigate();

  const [numero, setNumero] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [flash, setFlash] = useState(false);

  const inputRef = useRef(null);
  const flashTimer = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
    return () => clearTimeout(flashTimer.current);
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") validateRouleau();
  };

  const validateRouleau = async () => {
    if (!numero) return;

    setLoading(true);
    setError("");
    setData(null);

    try {
      const response = await axios.post(`${API_URL}/${numero}`);
      setData(response.data);

      // Confirmation sans regarder l'écran : voile vert + vibration. L'opérateur
      // enchaîne les rouleaux, il ne lit la fiche qu'en cas de doute.
      feedback();
      setFlash(true);
      clearTimeout(flashTimer.current);
      flashTimer.current = setTimeout(() => setFlash(false), 450);
    } catch {
      setError("Rouleau introuvable dans le système");
    } finally {
      setLoading(false);
      setNumero("");
      inputRef.current?.focus();
    }
  };

  const badge = data ? badgeScanEntree(data.scanStatus) : null;

  return (
    <div>
      <div className="page-header">
        <button className="btn-back" onClick={() => navigate("/")}>
          <IconChevronLeft />
          Retour
        </button>

        <div className="page-header-title">
          <IconEntree size={19} color="var(--accent-blue)" />
          Scan Entrée Rouleau
        </div>
      </div>

      <div className="scan-body">
        <div className="scan-field">
          <div className={`scan-flash ${flash ? "on" : ""}`} />
          <input
            ref={inputRef}
            type="text"
            inputMode="none" /* Prevents virtual keyboard from popping up if hardware scanner is used */
            placeholder="Scanner ou saisir le numéro..."
            value={numero}
            onChange={(e) => setNumero(e.target.value)}
            onKeyDown={handleKeyPress}
          />
        </div>

        {loading && (
          <div className="status-line">
            <span className="spinner" />
            Lecture en cours...
          </div>
        )}

        {error && (
          <div className="alert-error">
            <IconWarning />
            {error}
          </div>
        )}

        {data && (
          <div className="result-card">
            <div className={`pill pill--${badge.variant}`}>{badge.label}</div>

            {data.dateValidation && (
              <div className="result-date">
                Validé le : {formatDate(data.dateValidation)}
              </div>
            )}

            <h2 className="roll-number">{data.numeroRouleau}</h2>

            <div className="info-grid">
              <div><span>Métrage</span>{data.metrage} m</div>
              <div><span>Poids</span>{data.poids} kg</div>
              <div><span>Laize</span>{data.laize}</div>
              <div><span>Nuance</span>{data.nuance}</div>
            </div>

            <div className="divider" />

            <div className="info-grid">
              <div><span>Tissu</span>{data.tissuNom}</div>
              <div><span>Import</span>{data.numeroImport}</div>
              <div className="full"><span>Fournisseur</span>{data.fournisseurImport}</div>
            </div>

            {data.certificats?.length > 0 && (
              <>
                <div className="divider" />
                <h3 className="cert-title">Certifications</h3>

                <div className="cert-list">
                  {data.certificats.map((cert, i) => (
                    <div key={i} className="cert-card">
                      <img src={cert.logoUrl} alt={cert.nom} />
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
